import { CommonIconProps } from "./types";

export const MenuIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M3.99988 12C3.99988 12.2652 4.10523 12.5196 4.29277 12.7071C4.48031 12.8946 4.73466 13 4.99988 13C5.26509 13 5.51945 12.8946 5.70698 12.7071C5.89452 12.5196 5.99988 12.2652 5.99988 12C5.99988 11.7348 5.89452 11.4804 5.70698 11.2929C5.51945 11.1054 5.26509 11 4.99988 11C4.73466 11 4.48031 11.1054 4.29277 11.2929C4.10523 11.4804 3.99988 11.7348 3.99988 12Z"
      fill="url(#paint0_linear_0_308)"
    />
    <path
      d="M10.9999 12C10.9999 12.2652 11.1052 12.5196 11.2928 12.7071C11.4803 12.8946 11.7347 13 11.9999 13C12.2651 13 12.5194 12.8946 12.707 12.7071C12.8945 12.5196 12.9999 12.2652 12.9999 12C12.9999 11.7348 12.8945 11.4804 12.707 11.2929C12.5194 11.1054 12.2651 11 11.9999 11C11.7347 11 11.4803 11.1054 11.2928 11.2929C11.1052 11.4804 10.9999 11.7348 10.9999 12Z"
      fill="url(#paint1_linear_0_308)"
    />
    <path
      d="M17.9999 12C17.9999 12.2652 18.1052 12.5196 18.2928 12.7071C18.4803 12.8946 18.7347 13 18.9999 13C19.2651 13 19.5194 12.8946 19.707 12.7071C19.8945 12.5196 19.9999 12.2652 19.9999 12C19.9999 11.7348 19.8945 11.4804 19.707 11.2929C19.5194 11.1054 19.2651 11 18.9999 11C18.7347 11 18.4803 11.1054 18.2928 11.2929C18.1052 11.4804 17.9999 11.7348 17.9999 12Z"
      fill="url(#paint2_linear_0_308)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_0_308"
        x1="7.44603"
        y1="11.2615"
        x2="7.68146"
        y2="13.6831"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0063B4" />
        <stop offset="1" stopColor="#009AF7" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_0_308"
        x1="7.44603"
        y1="11.2615"
        x2="7.68146"
        y2="13.6831"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0063B4" />
        <stop offset="1" stopColor="#009AF7" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_0_308"
        x1="7.44603"
        y1="11.2615"
        x2="7.68146"
        y2="13.6831"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0063B4" />
        <stop offset="1" stopColor="#009AF7" />
      </linearGradient>
    </defs>
  </svg>
);

export const MenuBurgerIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_12856_18319)">
      <path d="M24 11H0V13H24V11Z" fill="white" />
      <path d="M24 4H0V6H24V4Z" fill="white" />
      <path d="M24 18H0V20H24V18Z" fill="white" />
    </g>
    <defs>
      <clipPath id="clip0_12856_18319">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const MenuBurgerLargeIcon = ({ height = 24, width = 24, color = "white" }: CommonIconProps) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4 6C4 5.44772 4.44772 5 5 5H19C19.5523 5 20 5.44772 20 6C20 6.55228 19.5523 7 19 7H5C4.44772 7 4 6.55228 4 6ZM4 10C4 9.44772 4.44772 9 5 9H19C19.5523 9 20 9.44772 20 10C20 10.5523 19.5523 11 19 11H5C4.44772 11 4 10.5523 4 10ZM4 14C4 13.4477 4.44772 13 5 13H19C19.5523 13 20 13.4477 20 14C20 14.5523 19.5523 15 19 15H5C4.44772 15 4 14.5523 4 14ZM4 18C4 17.4477 4.44772 17 5 17H19C19.5523 17 20 17.4477 20 18C20 18.5523 19.5523 19 19 19H5C4.44772 19 4 18.5523 4 18Z"
      fill={color}
    />
  </svg>
);
